import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import "./../../assets/css/Settings/SettingsSidebar.scss";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { GoArrowLeft } from "react-icons/go";
import {
  TbBell,
  TbLocation,
  TbUsers,
  TbUserCog,
  TbSettings,
  TbUser,
  TbTemplate,
  TbCurrencyPound,
} from "react-icons/tb";
import { FaAlignJustify, FaTimes } from "react-icons/fa";
import useTitanApp from "../../hooks/useTitanApp";

export default function SettingsSidebar() {
  const { appState } = useTitanApp();
  const { features, currentPharmacyId, isOrbitUser } = appState || {};
  const {
    ifSettingMinimal,
    ifMapEnabled,
    ifPharmacyDashboardEnabled,
    ifPatientListEnabled,
    ifAIConsultationEnabled,
  } = features || {};
  const location = useLocation();

  const isMenuItemActive = (link) => {
    return location.pathname === link || location.pathname.startsWith(link);
  };

  const navigate = useNavigate();

  const [showResponsiveSidebar, setShowResponsiveSidebar] = useState(false);

  const handleShowSidebar = () => {
    if (window.innerWidth < 800) {
      setShowResponsiveSidebar(!showResponsiveSidebar);
    }
  };

  const handleGoBack = () => {
    const settingBackUrl = localStorage.getItem("settingBackUrl");

    if (settingBackUrl === null) {
      if (!ifMapEnabled) {
        if (ifPharmacyDashboardEnabled) {
          navigate(`/pharmacy/dashboard/${currentPharmacyId}`, {
            replace: true,
          });
        } else if (ifPatientListEnabled) {
          navigate(`/pharmacypatient/${currentPharmacyId}`, { replace: true });
        } else {
          navigate(`/pharmacy/services/${currentPharmacyId}`, {
            replace: true,
          });
        }
      } else {
        navigate("/", { replace: true });
      }
    } else {
      try {
        const pathOnly = new URL(settingBackUrl).pathname;
        navigate(pathOnly);
      } catch (err) {
        console.error("Invalid settingBackUrl:", settingBackUrl);
        navigate("/", { replace: true }); // fallback
      }
    }
  };

  return (
    <div>
      <div
        className={`sidebarSettings_wrapper ${
          showResponsiveSidebar ? "show-sidebar" : ""
        }`}
      >
        <div className="settings_breadcrumb" onClick={handleGoBack}>
          <GoArrowLeft className="icons-color" />

          <p className="breadCrumb_title">Back to Dashboard</p>
        </div>

        <Sidebar className="settings_sidebar">
          <Menu>
            <MenuItem
              component={<Link to="/settings/general"></Link>}
              className={`no-submenu ${
                isMenuItemActive("/settings/general")
                  ? "settings-sidebar-selected"
                  : ""
              }`}
              icon={<TbBell size={20} />}
            >
              General
            </MenuItem>
            {!ifSettingMinimal && (
              <MenuItem
                component={<Link to="/settings/locations"></Link>}
                className={`no-submenu ${
                  isMenuItemActive("/settings/locations")
                    ? "settings-sidebar-selected"
                    : ""
                }`}
                icon={<TbLocation size={20} />}
              >
                Locations
              </MenuItem>
            )}
            {isOrbitUser && (
              <MenuItem
                component={<Link to="/settings/billing"></Link>}
                className={`no-submenu ${
                  isMenuItemActive("/settings/billing")
                    ? "settings-sidebar-selected"
                    : ""
                }`}
                icon={<TbCurrencyPound size={20} />}
              >
                Billing
              </MenuItem>
            )}
            <SubMenu label="Teams" defaultOpen={true} className="submenu-title">
              <MenuItem
                component={<Link to="/settings/teams/members"></Link>}
                icon={<TbUsers size={20} />}
                className={
                  isMenuItemActive("/settings/teams/members")
                    ? "settings-sidebar-selected"
                    : ""
                }
              >
                Members
              </MenuItem>
              {!ifSettingMinimal && (
                <MenuItem
                  component={<Link to="/settings/teams/roles"></Link>}
                  icon={<TbUserCog size={22} />}
                  className={
                    isMenuItemActive("/settings/teams/roles")
                      ? "settings-sidebar-selected"
                      : ""
                  }
                >
                  Roles
                </MenuItem>
              )}
            </SubMenu>

            <SubMenu
              label="Services"
              defaultOpen={true}
              className="submenu-title"
            >
              <MenuItem
                component={<Link to="/settings/services/types"></Link>}
                icon={<TbSettings size={20} />}
                className={
                  isMenuItemActive("/settings/services/types")
                    ? "settings-sidebar-selected"
                    : ""
                }
              >
                My Services
              </MenuItem>
            </SubMenu>

            {!ifSettingMinimal && (
              <SubMenu
                label="Template Forms"
                defaultOpen={true}
                className="submenu-title"
              >
                <MenuItem
                  component={
                    <Link to="/settings/templates/consultation"></Link>
                  }
                  icon={<TbUser size={22} />}
                  className={
                    isMenuItemActive("/settings/templates/consultation")
                      ? "settings-sidebar-selected"
                      : ""
                  }
                >
                  Consultation
                </MenuItem>
                {ifAIConsultationEnabled && (
                  <MenuItem
                    component={
                      <Link to="/settings/templates/aiconsultation"></Link>
                    }
                    icon={<TbUser size={22} />}
                    className={
                      isMenuItemActive("/settings/templates/aiconsultation")
                        ? "settings-sidebar-selected"
                        : ""
                    }
                  >
                    AI Consultation
                  </MenuItem>
                )}
              </SubMenu>
            )}
            {!ifSettingMinimal && (
              <SubMenu
                label="Communication"
                defaultOpen={true}
                className="submenu-title"
              >
                <MenuItem
                  component={
                    <Link to="/settings/communication/messagetemplate"></Link>
                  }
                  icon={<TbTemplate size={20} />}
                  className={
                    isMenuItemActive("/settings/communication/messagetemplate")
                      ? "settings-sidebar-selected"
                      : ""
                  }
                >
                  SMS & Email
                </MenuItem>
              </SubMenu>
            )}
          </Menu>
        </Sidebar>
      </div>
      <div className="sidebar-hamburger" onClick={handleShowSidebar}>
        {showResponsiveSidebar ? <FaTimes /> : <FaAlignJustify />}
      </div>
    </div>
  );
}
